import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-3 top-3 z-40 flex items-center justify-center gap-2 rounded-2xl bg-ink-800/90 px-4 py-2 text-sm text-warm-100 shadow-card backdrop-blur"
      style={{ paddingTop: 'max(0.5rem, var(--safe-top))' }}
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      <span>{t('offline.banner', "You're offline — showing cached data")}</span>
    </div>
  );
}
